import * as Yup from 'yup'
import { Form, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import { CheckboxInput, TextFieldInput } from '@dhl/formik'
import { Box, Button, Grid } from '@dhl-ui/components'

export type FormValues = {
  name?: string
  description?: string
  limitedTrackTrace?: boolean
}

export const createValidationSchema = (t: TFunction) =>
  Yup.object({
    name: Yup.string()
      .default('')
      .required(t('admin.integratorsPage.nameIsRequired'))
      .max(35, t('admin.integratorsPage.nameMax')),
  }).defined()

type Props = {
  onCancel: () => void
  disabled?: boolean
}

export const IntegratorForm = ({ onCancel, disabled = false }: Props) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()
  const disableFields = isSubmitting || disabled
  return (
    <Form data-testid="integrators-form">
      <Box pt={2}>
        <Grid container spacing={2} direction="column">
          <Grid size={{ sm: 3 }}>
            <TextFieldInput
              disabled={disableFields}
              fullWidth
              label={t('admin.integratorsPage.name')}
              name="name"
              type="text"
            />
          </Grid>
          <Grid size={{ sm: 12 }}>
            <TextFieldInput
              multiline
              fullWidth
              label={t('admin.integratorsPage.description')}
              name="description"
              type="text"
            />
          </Grid>
        </Grid>
        <Grid>
          <Box mt={2}>
            <CheckboxInput name="limitedTrackTrace" label={t('admin.integratorsPage.limited').toString()} />
          </Box>
        </Grid>
      </Box>
      <Box display="flex" justifyContent="flex-end" gap={1}>
        <Button data-testid="click-cancel" size="medium" color="primary" onClick={onCancel} disabled={isSubmitting}>
          {t('admin.integratorsPage.cancelButton')}
        </Button>
        <Button size="medium" color="primary" type="submit" variant="contained" disabled={isSubmitting}>
          {disabled ? t('admin.integratorsPage.updateButton') : t('admin.integratorsPage.addButton')}
        </Button>
      </Box>
    </Form>
  )
}
